import Hero from "./Hero";

function Homepage() {
  return <Hero />;
}

export default Homepage;
